module.exports = __webpack_public_path__ + "fonts/axiforma-regular.woff2";